module.exports = __webpack_public_path__ + "static/media/arrow-left-new.992a21ef.svg";